import { Discipline } from "@/types/discipline.types";

/**
 * Shared inbound mapper for both the REST `DashboardDisciplineRef` (`title:
 * string | null`) and the GraphQL discipline fragment (`title?: string | null`),
 * so the structural input covers both wire shapes.
 */
export const mapToDiscipline = (input: { id: number; title?: string | null }): Discipline => ({
  id: input.id,
  title: input.title ?? "",
});
